import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: ${myPalette.black.main};
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid ${myPalette.blue['500']};
  overflow: hidden;
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
  background: ${myPalette.blue['500']};
  padding: 8px 12px;
`

export const GridItemTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
`

export const GridItemValue = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  padding: 8px 12px;
`
